export type HrMenuGroupConfig = {
  key: string;
  name: string;
  locale: string;
  icon: string;
  childPaths: string[];
};

export const hrMenuGroupConfig: HrMenuGroupConfig[] = [
  {
    key: '/zy-hr/workbench',
    name: 'zy-hr.workbench',
    locale: 'menu.zy-hr.workbench',
    icon: 'dashboard',
    childPaths: ['/zy-hr/me', '/zy-hr/dashboard'],
  },
  {
    key: '/zy-hr/employee-center',
    name: 'zy-hr.employeeCenter',
    locale: 'menu.zy-hr.employeeCenter',
    icon: 'team',
    childPaths: [
      '/zy-hr/employee-workbench',
      '/zy-hr/employee',
      '/zy-hr/onboarding',
      '/zy-hr/regularization',
      '/zy-hr/resignation',
      '/zy-hr/employee-change',
      '/zy-hr/profile-change',
      '/zy-hr/employee-lifecycle-audits',
      '/zy-hr/labor-relations',
      '/zy-hr/certificate-requests',
      '/zy-hr/employee-relations-analysis',
      '/zy-hr/employee-portal-settings',
      '/zy-hr/employee-center/settings',
    ],
  },
  {
    key: '/zy-hr/attendance-center',
    name: 'zy-hr.attendanceCenter',
    locale: 'menu.zy-hr.attendanceCenter',
    icon: 'fieldTime',
    childPaths: [
      '/zy-hr/attendance/workbench',
      '/zy-hr/attendance/record',
      '/zy-hr/attendance/daily',
      '/zy-hr/attendance/monthly',
      '/zy-hr/attendance/leave',
      '/zy-hr/attendance/overtime',
      '/zy-hr/attendance/punch',
      '/zy-hr/attendance/shifts',
      '/zy-hr/attendance/groups',
      '/zy-hr/attendance/schedules',
      '/zy-hr/attendance/holiday-plans',
      '/zy-hr/attendance/leave-balances',
      '/zy-hr/attendance/leave-grant-policies',
      '/zy-hr/attendance/setting',
    ],
  },
  {
    key: '/zy-hr/payroll-center',
    name: 'zy-hr.payrollCenter',
    locale: 'menu.zy-hr.payrollCenter',
    icon: 'wallet',
    childPaths: [
      '/zy-hr/payroll/workbench',
      '/zy-hr/payroll/plans',
      '/zy-hr/payroll/items',
      '/zy-hr/payroll/profiles',
      '/zy-hr/payroll/deductions',
      '/zy-hr/payroll/adjustments',
      '/zy-hr/payroll/runs',
      '/zy-hr/payroll/slips',
    ],
  },
  {
    key: '/zy-hr/social-insurance-center',
    name: 'zy-hr.socialInsuranceCenter',
    locale: 'menu.zy-hr.socialInsuranceCenter',
    icon: 'safety',
    childPaths: [
      '/zy-hr/social-insurance/workbench',
      '/zy-hr/social-insurance/policies',
      '/zy-hr/social-insurance/accounts',
      '/zy-hr/social-insurance/changes',
      '/zy-hr/social-insurance/bills',
    ],
  },
  {
    key: '/zy-hr/foundation-config',
    name: 'zy-hr.foundationConfig',
    locale: 'menu.zy-hr.foundationConfig',
    icon: 'apartment',
    childPaths: [
      '/zy-hr/organization/unit',
      '/zy-hr/organization/position',
      '/zy-hr/organization/job-level',
      '/zy-hr/organization/work-location',
      '/zy-hr/organization/employee-tag',
      '/zy-hr/organization/roles',
      '/zy-hr/organization/permissions',
      '/zy-hr/approval-templates',
    ],
  },
  {
    key: '/zy-hr/process-reminder',
    name: 'zy-hr.processReminder',
    locale: 'menu.zy-hr.processReminder',
    icon: 'bell',
    childPaths: [
      '/zy-hr/approval',
      '/zy-hr/approval-records',
      '/zy-hr/approval-abnormal-records',
      '/zy-hr/approval-instances',
      '/zy-hr/approval-delegates',
      '/zy-hr/approval-handovers',
      '/zy-hr/reminder',
    ],
  },
  {
    key: '/zy-hr/performance-center',
    name: 'zy-hr.performanceCenter',
    locale: 'menu.zy-hr.performanceCenter',
    icon: 'barChart',
    childPaths: [
      '/zy-hr/performance/cycles',
      '/zy-hr/performance/goals',
      '/zy-hr/performance/reviews',
      '/zy-hr/performance/interviews',
      '/zy-hr/performance/results',
      '/zy-hr/performance/grade-rules',
    ],
  },
];
